/**
 * Change State Widget
 * Change the state of an element (active or not) and all the others state
 * ---> Use jQuery
 */

;(function state($) {

    $(document).ready(init);

    var BODY_CLASS = '.Body',
        CONTAINER_SEL = 'js-State',
        BTN_SEL = 'js-State-btn';

    function init() {
        var container = $('.' + CONTAINER_SEL),
            linkedCont = $('.' + CONTAINER_SEL + '[data-config="linked"]'),
            body = $(BODY_CLASS);

        // Secure the state on loading window
        container.attr('data-state', 'inactive');

        // Watch click on js-State class
        body.on('click', '.' + BTN_SEL, showContent);

        if (container.attr('data-config') === 'linked') {
            // Change the state on click outside the element
            body.click( function(e){
                var target = $(e.target);

                //  If it's not an interlinked Dropdown
                if (target.parents('.' + CONTAINER_SEL).length === 0) {
                    linkedCont.attr('data-state', 'inactive');
                }
            });
        }
    }

    function showContent(e) {
        e.stopPropagation();

        var btn = $(e.currentTarget),
            container = btn.parents('.' + CONTAINER_SEL),
            containers = $('.' + CONTAINER_SEL), // All the state container
            at = 'data-state';

        if ( container.attr(at) !== 'active') {
            containers.attr(at, 'inactive');
            container.attr(at, 'active');

        } else {
            container.attr(at, 'inactive');
        }
    }
})(jQuery);
